import React, { FC } from 'react';
import { Colors } from '../../../../styles/colors';

interface Props {
  color: string;
}
export const ProductIconEnergieAudit: FC<Props> = ({ color = Colors.white }) => {
  return (
    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 98.6 95.8" fill="currentColor" style={{ color }} xmlSpace="preserve">
      <path d="M87.3,95.8H0V67.6h87.3l11.3,14.1L87.3,95.8z M17.5,75.9c1-1.1,2.5-1.8,4.1-1.7c1.1,0,2.2,0.3,3.1,1
        c0.8,0.7,1.4,1.6,1.7,2.7l4.5-1c-0.4-1.5-1.2-2.9-2.3-4c-1.9-1.6-4.3-2.5-6.7-2.4c-2.9-0.1-5.6,1-7.6,3c-1.9,2-2.9,4.8-2.9,8.4
        c-0.2,3,0.9,5.9,2.9,8.1c1.9,2,4.6,3.1,7.4,3c2.1,0.1,4.2-0.5,6-1.7c1.7-1.3,2.9-3.2,3.4-5.4l-4.4-1.4c-0.2,1.3-0.9,2.6-1.9,3.5
        c-0.9,0.7-2,1.1-3.1,1.1c-1.5,0-3-0.6-4-1.8c-1-1.2-1.6-3.1-1.6-5.9C16,78.9,16.5,77.1,17.5,75.9 M0,62V33.8h64.8L76,47.9L64.8,62H0
        z M29.9,49.2c-0.9-1-2-1.7-3.3-2c1-0.4,1.8-1.1,2.4-2c0.6-0.9,0.9-1.9,0.9-2.9c0-0.9-0.2-1.8-0.7-2.6c-0.5-0.8-1.1-1.4-1.8-1.9
        c-0.7-0.5-1.6-0.8-2.5-0.9c-1.4-0.2-2.8-0.2-4.2-0.2h-9.4v22.5h8c3,0,5-0.1,5.7-0.2c1.1-0.1,2.2-0.5,3.2-1.1c0.9-0.6,1.6-1.4,2-2.3
        c0.5-0.9,0.7-2,0.8-3C31,51.4,30.6,50.2,29.9,49.2 M23.7,55.2c-1.1,0.1-2.2,0.2-3.3,0.1H16v-6h3.8c1.4-0.1,2.8,0,4.2,0.3
        c1.2,0.3,2.1,1.5,2,2.8c0,0.7-0.2,1.4-0.7,1.9C24.9,54.8,24.3,55.1,23.7,55.2 M22.6,45.5c-0.4,0.1-1.6,0.1-3.5,0.1H16v-5.2h2.7
        c2.2,0,3.6,0,4.1,0.1c0.7,0,1.3,0.3,1.8,0.8c0.4,0.5,0.6,1.1,0.6,1.7c0,0.7-0.2,1.3-0.7,1.8C24,45.2,23.3,45.5,22.6,45.5 M0,28.2V0
        h39.4l11.3,14.1L39.4,28.2H0z M22.2,2.8h-4.9L8.4,25.4h4.9l1.9-5.1h9.1l2,5.1h5L22.2,2.8z M19.7,8.1l3.1,8.4h-6.2L19.7,8.1z"/>
    </svg>
  );
}
